import { TemplateData, TemplateParams } from '.';

const completionExpirationOthers = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'courses',
  email: {
    buttonEnabled: true,
    buttonLink: '{{courseAdminUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.completionExpirationIntroAdmin}
      </p>
      <p>
        {{usersList}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.completionExpirationSubjectAdmin}`
  },
  placeholders: {
    courseTitle: {
      label: messages.coursesCourseTitle,
      example: 'Test course'
    },
    courseAdminUrl: {
      label: messages.commonCourseAdminLink,
      example: `${serverConfig.adminUrl}/courses/test-course/follow/users`
    },
    usersList: {
      label: messages.emailExpiringCompletionsUsersList
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCompletionExpirationOthers
});

export default completionExpirationOthers;
